// Returns the url encoded string
export default function (value) {
  if (!value) return "";
  return encodeURIComponent(value);
}
